import { render, staticRenderFns } from "./Importados.vue?vue&type=template&id=2cc7ce6e&scoped=true&"
import script from "./Importados.vue?vue&type=script&lang=js&"
export * from "./Importados.vue?vue&type=script&lang=js&"
import style0 from "./Importados.vue?vue&type=style&index=0&id=2cc7ce6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc7ce6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
